var app = angular.module('directives.metallist');

app.directive('metallist', [
    'configs',
    '$state',
    function (configs, $state) {
        var tmplUrl;

        try {
            tmplUrl = require('../templates/' + $state.current.name.replace('pages.', '') + '.html');//looking for template with moduleName
        } catch (e) {
            tmplUrl = require('../templates/index.html')//if error(no such file), use default template
        }

        return {
            template: tmplUrl,
            controller: 'metallistCtrl',
            link: function (scope, element, attrs, ctrl) {
            }
        }

    }
]);

app.controller('metallistCtrl', function ($scope, PortalApi, $stateParams, $compile, Notification, $translate, Localization, configs, $state, Pay, AmountCommission) {

    Pay.data.metallist = {
        eventSelected:{},
        temp: '',
        seats:[],
        seatsId: '',
        start: false,
        sectorSelected: '',
        sectorId: 0,
        total: 0
    };

    $scope.getBookingEvents = function() {

        $scope.shakhterLoader = true;
        Pay.data.metallist.step = 1;

        PortalApi.getEventsMetalist(Pay.data.serviceId).then(function(events) {
            Pay.data.metallist.events = events;
            $scope.shakhterLoader = false;

            /*if stateParam has eventId to go*/
            if($stateParams.toEvent){
                events.forEach(function (event) {
                    if(event.EventId == $stateParams.toEvent){
                        $scope.getStadium($stateParams.toEvent, event.Limit, event.EventName,  event.EventStart);
                    }
                });
                $stateParams.toEvent = null;
            }
            /*end stateParams*/
        }, function(reason) {
            if(reason.data.text_сode == 'SESSION_ERROR'){
                Localization.notifyTemplate('error', 'ACTIONS.SIGNOUT', 5, true);
                $state.go('pages.payment',{serviceId:configs.payments_config.service.metallist});
            }
        });
    };

    $scope.getStadium = function(id, limit, eventName, eventTime) {

        var fullSector;
        Pay.data.metallist.limit = limit;
        Pay.data.preLoader = true;
        Pay.data.metallist.eventName = eventName;
        Pay.data.metallist.eventTime = eventTime;
        Pay.data.metallist.eventId = id;
        Pay.data.metallist.step = 2;
        Pay.data.metallist.seats = [];
        Pay.data.metallist.temp = '';
        Pay.data.metallist.seatsId = '';
        Pay.data.metallist.total = 0;
        Pay.data.metallist.sectorSelected = '';

        $scope.clearSVG();

        var data = {
            eventId: Pay.data.metallist.eventId,
            serviceId:  Pay.data.serviceId
        };
        PortalApi.getStadiumScheme(data).then(function(resolve) {
            Pay.data.preLoader = false;
            fullSector = $compile(resolve.schemeSvg)($scope)[0];
            Pay.data.metallist.stadiumScheme = fullSector;

            Pay.data.metallist.sectorsInfo = resolve.sectors;
            angular.element('#schemeStd').append(Pay.data.metallist.stadiumScheme);
            angular.element('#svgshema').attr('style','height: 750px;');

            Pay.data.metallist.sectorsInfo.forEach(function (sector) {
                if (sector.FreeSeatsCount > 0) {

                    fullSector = angular.element(document.querySelectorAll("[data-sector-id='"+sector.Id+"']"));

                    if (fullSector) {
                        fullSector.attr("ng-click", "getSectorSeats(" + sector.Id + ")");
                        fullSector.attr("class", "activeSector");
                        $translate('METALLIST.SEATS_AVAILABLE', {seats: sector.FreeSeatsCount}).then(function (text) {
                            angular.element(document.querySelectorAll("[data-sector-id='"+sector.Id+"']")).children().attr({'uib-tooltip': text,'data-tooltip-append-to-body':'true'});
                            $compile(angular.element(document.querySelectorAll("[data-sector-id='"+sector.Id+"']")))($scope);
                        });
                    }

                }else{
                    angular.element(document.querySelectorAll("[data-sector-id='"+sector.Id+"']")).attr('style','opacity: .1;');
                }
            });

        }, function(reason) {
            if(reason.data.text_сode == 'SESSION_ERROR'){
                Localization.notifyTemplate('error', 'ACTIONS.SIGNOUT', 5, true);
                $state.go('pages.payment',{serviceId:configs.payments_config.service.metallist});
            }
        })
    };

    $scope.getSectorSeats = function(sectorId) {

        angular.element(document.getElementsByClassName('tooltip')).attr('style','display:none');

        var sector,sectorHeight;
        Pay.data.preLoader = true;
        Pay.data.metallist.step = 3;
        Pay.data.metallist.seats = [];
        Pay.data.metallist.sectorId = sectorId;

        $scope.clearSVG();

        for (var i = 0; i < Pay.data.metallist.sectorsInfo.length; i++) {
            if (Pay.data.metallist.sectorId == Pay.data.metallist.sectorsInfo[i].Id) {
                Pay.data.metallist.sectorSelected = Pay.data.metallist.sectorsInfo[i].Name;
                break;
            }
        }

        var data = {
            eventId: Pay.data.metallist.eventId,
            serviceId:  Pay.data.serviceId,
            sectorId: sectorId
        };
        PortalApi.getSectorScheme(data).then(function(resolve) {
            Pay.data.preLoader = false;
            sectorHeight = resolve.sectorHeight;
            sector = $compile(resolve.schemeSvg)($scope)[0];

            angular.element('#schemeSec').append(sector);
            angular.element('#svgsectorshema').attr('style','height:' + sectorHeight + 'px;');

            Pay.data.metallist.eventSelected = {
                selectedSector: sector,
                sessionId: resolve.sessionId,
                places: resolve.places
            };

            Pay.data.metallist.eventSelected.places.forEach(function (row) {
                row.forEach(function (place) {
                    if (place.Status == 0) {

                        var seatInfo = [place.SeatId, place.Price, place.RowText, place.SeatText];

                        angular.element("#" + place.SeatId).attr("class", "active place");
                        angular.element("#" + place.SeatId).attr("ng-click", "addSeat(" + seatInfo + ")");

                        $translate('METALLIST.SEAT_PRICE', {price: Math.round(place.Price)}).then(function (text) {
                            angular.element("#" + place.SeatId).attr({'uib-tooltip': text,'data-tooltip-append-to-body':'true'});
                        });

                    } else {
                        angular.element("#" + place.SeatId).attr("class", "inactive");
                    }
                });
            });
            setTimeout(function () {
                $compile(angular.element('#svgsectorshema'))($scope)[0];
            }, 1000);

        }, function(reason) {
            if(reason.data.text_сode == 'SESSION_ERROR'){
                Localization.notifyTemplate('error', 'ACTIONS.SIGNOUT', 5, true);
                $state.go('pages.payment',{serviceId:configs.payments_config.service.metallist});
            }
        });
    };
    $scope.addSeat = function(id, price, row, seat) {
        var temp = {
                id: id,
                price: price,
                row: row,
                seat: seat
            },
            seatsId = Pay.data.metallist.temp,
            double = false;

        for (var i = 0; i < Pay.data.metallist.seats.length; i++) {
            if (Pay.data.metallist.seats[i].id == temp.id) {
                double = true;
                angular.element("#" + id).attr("class", "active");

                Pay.data.metallist.total -= temp.price;
                Pay.data.metallist.seats.splice(i, 1);
                Pay.data.metallist.temp = seatsId.replace(temp.id + ',', '');

            }
        }

        if ((Pay.data.metallist.seats.length + 1) <= Pay.data.metallist.limit) {
            if (!double) {
                Pay.data.metallist.seats.push(temp);
                Pay.data.metallist.total += temp.price;
                angular.element("#" + id).attr("class", "active selected");
                // document.getElementById(id).setAttribute("class", "active selected");

                Pay.data.metallist.temp += temp.id + ',';
            }

            Pay.data.metallist.seatsId = Pay.data.metallist.temp.slice(0, -1);
        } else {
            return $translate('BOOKING.LIMIT_ERROR').then(function (translation) {
                Notification.error({
                    message: translation,
                    delay: 1000
                });
            });
        }
    };

    $scope.backEvent = function(step, eventName) {
        if (step == 2) {
            $scope.getBookingEvents();
        } else if (step == 3) {
            $scope.getStadium(Pay.data.metallist.eventId, Pay.data.metallist.limit, eventName);
        } else {
            $state.go('pages.payment',{serviceId:configs.payments_config.service.metallist});
        }
    };

    $scope.clearSVG = function() {
        if (angular.element('#svgshema')) {
            angular.element('#svgshema').remove();
            Pay.data.metallist.stadiumScheme = '';
        }
        if (angular.element('#svgsectorshema')) {
            angular.element('#svgsectorshema').remove();
            Pay.data.metallist.eventSelected = {};
        }
    };

    $scope.checkTickets = function() {
        var data = {
            data: {
                checkMask: {
                    changeForMask: false
                }
            },
            payment: {
                service_id: Pay.data.serviceId,
                order_id: +new Date()
            },
            fields: Pay.fields,
        };

        for (var i = 0; i < data.fields.length; i++) {
            if (data.fields[i].name == 'eventId') {
                data.fields[i].value = Pay.data.metallist.eventId;
            }

            if (data.fields[i].name == 'sessionId') {
                data.fields[i].value = Pay.data.metallist.eventSelected.sessionId;
            }

            if (data.fields[i].name == 'seats') {
                data.fields[i].value = Pay.data.metallist.seatsId;
            }

            if (data.fields[i].name == 'sectorId') {
                data.fields[i].value = Pay.data.metallist.sectorId;
            }

            if (data.fields[i].name == 'limit') {
                data.fields[i].value = Pay.data.metallist.limit;
            }
        }

        Pay.data.preLoader = true;
        PortalApi.checkPayment(data).then(function(response) {
            Pay.data.preLoader = false;

            if (response.status != 'ok') {
                return $translate('NOTIFICATION.ERROR.CHECK_PAYMENT_ERROR').then(function(translation) {
                    Notification.error({
                        message: translation,
                        delay: 1000
                    });
                });
            } else {//todo remove '$scope.' from $scope.pay after merge with modules and inject 'Pay' service
                Pay.data.metallist.check = response;
                $scope.pay.payment.id = Pay.data.metallist.check.id;
                Pay.data.metallist.step = 4;
                $scope.pay.AmountSubsidyDif = $scope.pay.amountInput = response.data.TotalPrice;
                AmountCommission.localCalcCommission();
                $scope.pay.innerState = 'confirm';

                var crData = {
                    amountInput: Pay.data.metallist.total,
                    service: Pay.data.getService.service,
                    subsidy: 0
                };
                PortalApi.createPayment($scope.pay.payment.id, crData);
            }
        }, function(reason) {
            if (reason.data.text_сode == 'SESSION_ERROR') {
                Localization.notifyTemplate('error', 'ACTIONS.SIGNOUT', 5, true);
                $state.go(
                    'pages.payment',
                    {
                        serviceId: configs.payments_config.service.metallist
                    }
                );
            }
        });
    };
});



/*****************
 ** WEBPACK FOOTER
 ** ./app/directives/metallist/directives/metallist.directive.js
 ** module id = 184
 ** module chunks = 1
 **/